// Game rendering functions - ゲーム描画のオーケストレーター

import { drawParticles } from '../../features/particles/particle-renderer';
import { drawPlayerBullets, drawEnemyBullets } from './bullet-renderer';
import { drawItems } from '../../features/items/item-renderer';
import { drawEnemies } from '../../features/enemy/renderer/enemy-renderer';
import { drawPlayer } from '../../features/player/renderer/ship-renderer';
import { renderBombEffect } from '../../features/abilities/bomb-effects';
import { renderCannonEffect } from '../../features/abilities/cannon-effects';
import { renderHomingEffect } from '../../features/abilities/homing-effects';
import { getIsBombActive, getCannonCharging, getCannonActive, getHomingActive, getDyingFadeAlpha } from '../../store/index';
import { getP5 } from '../../core/p5-instance';

/**
 * drawGame() - ゲームオブジェクトの描画
 * 各レンダラーを呼び出して画面を構成
 *
 * 描画順序:
 * 1. パーティクル（背景エフェクト）
 * 2. プレイヤーの弾丸
 * 3. 敵の弾丸
 * 4. アイテム
 * 5. 敵
 * 6. ボム / 荷電粒子砲 / ホーミング エフェクト
 * 7. プレイヤー（最前面）
 */
export function drawGame() {
    drawParticles(); // 死亡エフェクトはフェードしない

    const fadeAlpha = getDyingFadeAlpha();

    // フェード完了時は弾・アイテムの描画をスキップ
    if (fadeAlpha > 0) {
        const ctx = getP5().drawingContext as CanvasRenderingContext2D;
        const needsFade = fadeAlpha < 1;
        if (needsFade) {
            ctx.save();
            ctx.globalAlpha = fadeAlpha;
        }

        drawPlayerBullets();
        drawEnemyBullets();
        drawItems();

        if (needsFade) {
            ctx.restore();
        }
    }

    // 敵はボス除外のため個別にフェード処理（enemy-renderer内）
    drawEnemies();

    // 特殊能力エフェクト
    if (getIsBombActive()) {
        renderBombEffect();
    }
    if (getCannonCharging() || getCannonActive()) {
        renderCannonEffect();
    }
    if (getHomingActive()) {
        renderHomingEffect();
    }

    drawPlayer();
}
